import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {SettingModel} from "../models/setting.model";

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private readonly _apiUrl = environment.apiUrl+ 'api/';

  constructor(
    private readonly _http: HttpClient
  ) { }

  getAll(): Observable<SettingModel[]> {
    const url = `${this._apiUrl}settings`;

    return this._http.get<SettingModel[]>(url);
  }

  getBySlug(slug: string): Observable<SettingModel> {
    const url = `${this._apiUrl}settings/slug?slug=${slug}`;

    return this._http.get<SettingModel>(url);
  }
}
